<template>
    <div class="scan_detail_">
        <div class="scan_detail_header">基础信息</div>
        <div class="scan_detail_main">
            <div class="scan_row">
                <div class="scan_row_text">钢筋笼编号：</div>
                <div class="scan_row_data">{{reinsInfo&&reinsInfo.produceNumber}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">尺寸：</div>
                <div class="scan_row_data">{{reinsInfo&&reinsInfo.sizeName}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">配筋：</div>
                <div class="scan_row_data">{{reinsInfo&&reinsInfo.reinforcementName}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">块号：</div>
                <div class="scan_row_data">{{reinsInfo&&reinsInfo.blockNumName}}</div>
            </div>
            <!-- <div class="scan_row">
                <div class="scan_row_text">生产班组：</div>
                <div class="scan_row_data">{{reinsInfo.bigPosition}}</div>
            </div> -->
            <div class="scan_row">
                <div class="scan_row_text">制作人：</div>
                <div class="scan_row_data">{{reinsInfo&&reinsInfo.createUserName}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">生产日期：</div>
                <div class="scan_row_data">{{reinsInfo&&reinsInfo.printTime}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">质检人：</div>
                <div class="scan_row_data">{{reinsInfo&&reinsInfo.steelCheckUserName}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">质检日期：</div>
                <div class="scan_row_data">{{reinsInfo&&reinsInfo.pipeCheckTime}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            reinsInfo:[],//钢筋笼信息
            url:null,//传参
        }
    },
    mounted(){
        this.getDeviceInnfo()
    },
    methods:{
        //获取设备信息
        getDeviceInnfo(){
            this.url = window.location.href.split('?')[1].split('=')[1]
            window.document.title="钢筋笼信息"
            this.$api.Scan.searchReinInfo({num:this.url}).then(res=>{
                if(res.statusMsg === 'ok'){
                    this.reinsInfo = res.data
                }else{
                    this.$message.warnning(res.statusMsg)
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.scan_detail_{
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    display: flex;
    flex-direction: column;
    background-color: #0C264A;

    .scan_detail_header{
        height: 50px;
        color: rgba(255,255,255,.88);
        font-size: 16px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        background:url("../../assets/scan/scan_header_bg.png") no-repeat;
        background-size: 100% 100%;
        background-position: center;
    }
    .scan_detail_main{
        margin-top: 10px;

        .scan_row{
            display: flex;
            background: url("../../assets/scan/scan_main_rowbg.png") no-repeat;
            background-size: 100% 100%;
            margin-top: 10px;
            padding: 10px 15px;
            .scan_row_text{
                font-size: 15px;
                flex: none;
                color: rgba(255,255,255,.72);
            }
            .scan_row_data{
                font-size: 15px;
                flex: 1;
                color: #3DC8FF;
            }
        }
    }
}
</style>